/**
 * Transfer Subscription Accendo Reducer
 */

import { Actions } from "containers/TransferSubscriptionAccendo/store/Actions";
import { Reducer } from "redux";
import { getTransferFormTranslations } from "root/shared/MultiLanguage";
import { IInputProps } from "root/store/CajitaStore";
import { ITransferSubscriptionAccendoActionCreator } from "types/transfer_subscription_accendo_action_creator";
import { ITransferSubscriptionAccendoFormProps } from "types/transfer_subscription_accendo_form_props";

const initialState: ITransferSubscriptionAccendoFormProps = {
  isValid: false,
  documentEmailInput: {
    container: "transfer",
    value: "",
    classContainer: "inputContainer email-transfer-input",
    valid: true,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[a-zA-Z0-9._!#$%&'*+-/=?^`{|}~@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
    },
    attributes: {
      id: "documentEmailInput",
      type: "text",
    },
  },
  translation: getTransferFormTranslations(),
};

// tslint:disable-next-line:max-func-body-length
const TransferSubscriptionAccendoReducer: Reducer<
  ITransferSubscriptionAccendoFormProps
> = (
  state: ITransferSubscriptionAccendoFormProps = initialState,
  action: ITransferSubscriptionAccendoActionCreator
): ITransferSubscriptionAccendoFormProps => {
  let input: IInputProps;

  switch (action.type) {
    case Actions.UPDATE_TRANSFER_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_TRANSFER_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.SET_TRANSFER_SUBSCRIPTION_ACCENDO_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.SWITCH_TRANSFER_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    default:
      return state;
  }
};

export { TransferSubscriptionAccendoReducer };



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptionAccendo/store/Reducer.tsx